import './EvaluationCriteria.scss';

function EvaluationCriteria({ children }) {
  return (
    <div className="eval-criteria-question">
      <label>{children}</label>
    </div>
  );
}

export default EvaluationCriteria;